import { useState } from "react";
import { useStyletron } from "baseui";
import { useCreateResourceGroupMutation } from "../../../services/resourceGroups/resourceGroupApi";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useReportMutationState } from "../../../hooks/useReportMutationState";

function CreateResourceGroupDialog({ subscriptionId, isOpen, setIsOpen }) {
  const [name, setName] = useState("");
  const [css, theme] = useStyletron();
  const [createRg, createRgResult] = useCreateResourceGroupMutation();
  useReportMutationState(createRgResult, () => setIsOpen(false));
  const inputsValid = name !== "";

  function close() {
    setIsOpen(false);
  }

  async function addRg() {
    await createRg({ name: name, subscriptionId: subscriptionId });
  }

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Add new Resource Group</ModalHeader>
        <ModalBody>
          <FormControl label={() => "Name"} caption={() => "Enter a descriptive name for the Resource Group"}>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              placeholder="Enter name ..."
              clearable
              clearOnEscape
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            Cancel
          </ModalButton>
          <ModalButton disabled={!inputsValid} isLoading={createRgResult.isLoading} onClick={addRg}>
            Okay
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default CreateResourceGroupDialog;
